import type { PageProps } from 'gatsby';
import React from 'react';

import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

// import PatientDrilldown from '@views/Insights/Drilldown';
import PatientDrilldown from '@views/Clients/Drilldown';

export default function PatientOverviewPage({ params: { id } }: PageProps) {
  return (
    <RoleGuard roles={[RoleName.Practitioner]}>
      <PatientDrilldown id={id} />
    </RoleGuard>
  );
}
